export enum SpecialsSortKey {
  topSellers = 'topSellers',
  endingSoon = 'endingSoon',
  newest = 'newest',
}

export type SpecialsSortOption = {
  key: SpecialsSortKey;
  label: string;
};

export const SPECIALS_SORT_OPTIONS: SpecialsSortOption[] = [
  { key: SpecialsSortKey.topSellers, label: 'Top Sellers' },
  { key: SpecialsSortKey.endingSoon, label: 'Ending Soon' },
  { key: SpecialsSortKey.newest, label: 'Newest' },
];

export const SPECIALS_SORT_QUERY_PARAM = 'specialsSort';
